import {
  CommodityAssignee,
  CommodityMilestone,
  CommodityType,
  CreateBlockError,
  CreateBlockInput,
  CrewMemberAssignment,
  Facility,
  WorkPackage,
} from '@bechtel/types';
import { PureQueryOptions, RefetchQueriesFunction } from '@apollo/client';
import { Commodity } from '~/types';

export interface GroupCommodities {
  [key: string]: Commodity[];
}
export interface CreateBlockProps {
  workPackageId: WorkPackage['id'];
  workPackageTag: WorkPackage['tag'];
  assignedCrewMembers?: CrewMemberAssignment[];
  weldCommodityAssignees?: CommodityAssignee[];
  facilities: Facility[];
  close?: () => void;
  commodities?: GroupCommodities;
  commodityTypes?: CommodityType[];
  multiBlock?: boolean;
  selectedMilestone?: CommodityMilestone;
  refetchQueries?: (string | PureQueryOptions)[] | RefetchQueriesFunction;
}

export interface CommodityList {
  id: Commodity['id'];
  tag: Commodity['tag'];
  type: CommodityType;
  milestones: {
    id: CommodityMilestone['id'];
    name: CommodityMilestone['name'];
  }[];
}

export interface FormikState {
  comments: CreateBlockInput['comments'];
  blockTypeId: CreateBlockInput['blockTypeId'];
  milestoneIds: CreateBlockInput['milestoneIds'];
  mediaMetadata: CreateBlockInput['attachmentMetadata'];
  commodityType: string;
  commodityList: CommodityList[];
  showMilestone: boolean;
}

export interface BlockNotCreatedProps {
  onClose: () => void;
  blockErrors: {
    [key: string]: CreateBlockError[];
  };
}
